import { useEffect, useState } from 'react'
import useFhirResource from './useFhirResource'

interface Payload {
  resource?: string
  resourceId?: string | undefined
  searchTerms?: string | undefined
  memberId?: string | undefined
}

const usePaginatedFhirResource = (initialPayload: Payload, pageSize: number) => {
  const [page, setPage] = useState('1')
  const [currentPage, setCurrentPage] = useState(1)
  const [pageState, setPageState] = useState('')
  const [searchTerms, setSearchTerms] = useState(initialPayload.searchTerms)

  const payload = {
    ...initialPayload,
    page,
    pageState,
    pageSize,
  }

  const { data, refetch, isStale, isFetching, isLoading, isSuccess, remove, isError } = useFhirResource(payload)

  const totalPages = data?.total ? Math.ceil(data.total / pageSize) : 1

  useEffect(() => {
    if (data?.link && !pageState) {
      const anyLink = data.link.find((l: any) => {
        const params = new URL(l.url).searchParams
        return params.get('_getpages')
      })
      if (anyLink) {
        const token = new URL(anyLink.url).searchParams.get('_getpages') || ''
        setPageState(token)
      }
    }
  }, [data])

  useEffect(() => {
    refetch()
  }, [page, refetch])

  useEffect(() => {
    setPage('1')
    setPageState('')
    setCurrentPage(1)
  }, [initialPayload.resource])

  const handleChangePage = (pageNumber: number) => {
    const relation =
      pageNumber > currentPage ? 'next' :
        pageNumber < currentPage ? 'previous' :
          'self'

    const link = data?.link?.find(
      (link: any) => link.relation === relation
    )

    const pageValue = link
      ? new URL(link.url).searchParams.get('page')
      : null

    setPage(pageValue || pageNumber.toString())
    setCurrentPage(pageNumber)
  }

  const handleNewSearch = () => {
    if (initialPayload.searchTerms !== searchTerms) {
      setSearchTerms(initialPayload.searchTerms)
      setPage('1')
      setPageState('')
      setCurrentPage(1)
    }
  }

  return { data, refetch, isStale, isSuccess, isLoading, remove, isError, isFetching, handleChangePage, totalPages, currentPage, handleNewSearch }
}

export default usePaginatedFhirResource